import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import FlavorSystemTable from './FlavorSystemTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_FLAVOR_ROUTE, ADD_NEW_TEXT, FLAVOR_TEXT } from 'constants/index';

const FlavorSystem: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{FLAVOR_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_FLAVOR_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <FlavorSystemTable />
    </Fragment>
  );
};

export default FlavorSystem;
